import type { RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/secondHandCar',
    name: 'secondHandCar',
    meta: {
      title: '',
      isApp: true,
      auth: false,
    },
    component: () => import('@/views/secondHandCar/index.vue'),
  },
  {
    path: '/secondHandCar/oldOwner',
    name: 'oldOwner',
    meta: {
      title: '车辆所属权变更',
      isApp: true,
      auth: false,
    },
    component: () => import('@/views/secondHandCar/oldOwner.vue'),
  },
  {
    path: '/secondHandCar/newOwner',
    name: 'newOwner',
    meta: {
      title: '个人二手车绑定',
      isApp: true,
      auth: false,
    },
    component: () => import('@/views/secondHandCar/newOwner.vue'),
  },
  {
    path: '/secondHandCar/publicOwner',
    name: 'publicOwner',
    meta: {
      title: '公司二手车绑定',
      isApp: true,
      auth: false,
    },
    component: () => import('@/views/secondHandCar/publicOwner.vue'),
  },
  {
    path: '/secondHandCar/faceCallback',
    name: 'faceCallback',
    meta: {
      title: '二手车资料提交',
      isApp: true,
      auth: false,
    },
    component: () => import('@/views/secondHandCar/faceCallback.vue'),
  },
  {
    path: '/secondHandCar/privacyAgreement',
    name: 'privacyAgreement',
    meta: {
      title: '车辆换绑隐私协议',
      isApp: true,
      auth: false,
    },
    component: () => import('@/views/secondHandCar/privacyAgreement.vue'),
  },
]

export default routes
